window.EmailPreferences = {}